<!--<div>-->
  <button type="button" class="btn btn-default">Yesterday</button>
  <button type="button" class="btn btn-default">Today</button>
  <button type="button" class="btn btn-default">Within 1 Year</button>
  <button type="button" class="btn btn-default">Within 20+ Years</button>
  <button type="button" class="btn btn-default">Date Range</button>
<!--</div>-->
